import {
  ACTION_CREATE_CUSTOM_BANNER__REQUEST,
  ACTION_CREATE_CUSTOM_BANNER__SUCCESS,
  ACTION_CREATE_CUSTOM_BANNER__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_CUSTOM_BANNER__REQUEST:
    case ACTION_CREATE_CUSTOM_BANNER__SUCCESS:
      return null;

    case ACTION_CREATE_CUSTOM_BANNER__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
